import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';

const state = {
  toolBookStatementStocksList: {
    state: '',
    list: [],
    total: 0,
  }
};

const getters = {
  getToolBookStatementStocksList: (state) => state.toolBookStatementStocksList,
};

const mutations = {
  [types.ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST]({toolBookStatementStocksList}, result){
    extend(toolBookStatementStocksList, result);
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/inventoryManagement/index.js